<ui-card
    [loading]="isLoading"
    role="group"
    [attr.aria-label]="'time-off-v3.policyComponents.basicInformationCard.header' | translate"
>
    <app-segment-header title="time-off-v3.policyComponents.basicInformationCard.header">
        <div *ngIf="editMode" class="buttons">
            <ui-button type="link" url="../basic-information"> {{ 'edit' | translate }} </ui-button>
        </div>
    </app-segment-header>

    <div class="field-container">
        <div class="label">{{ 'time-off-v3.policyComponents.basicInformationCard.policyName' | translate }}</div>
        <div>{{ timeOffPolicy?.name }}</div>
    </div>

    <div class="field-container">
        <div class="label">{{ 'time-off-v3.policyComponents.basicInformationCard.timeOffType' | translate }}</div>
        <div>{{ timeOffPolicy.timeOffType?.name }}</div>
    </div>

    <div class="field-container">
        <div class="label">{{ 'time-off-v3.policyComponents.basicInformationCard.approvalFlow' | translate }}</div>
        <div>{{ timeOffPolicy.timeOffApprovalFlow?.name }}</div>
    </div>
</ui-card>
